import classNames from 'classnames'
import { Controller, useFormContext } from 'react-hook-form'
import Form from 'react-bootstrap/Form'

import './Select.scss'

export type SelectOption = {
  label: string
  value: string | number
}

export type Props = {
  className?: string
  horizontal?: boolean
  label?: string
  name: string
  options: SelectOption[]
  showErrorMessage?: boolean
  showValidation?: boolean
}

export const Select = ({
  className,
  horizontal,
  label,
  name,
  options,
  showErrorMessage = true,
  showValidation = true,
}: Props) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <Form.Group
          className={classNames(className, { 'd-flex align-items-center': horizontal })}
          controlId={name}
        >
          {label && (
            <Form.Label className={classNames({ 'me-2 mb-0': horizontal })}>{label}</Form.Label>
          )}
          <Form.Select
            isInvalid={showValidation && fieldState.isTouched && Boolean(fieldState.error)}
            name={field.name}
            onBlur={field.onBlur}
            onChange={field.onChange}
            ref={field.ref}
            value={(field.value as string | number | undefined) ?? ''}
          >
            {options.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Form.Select>
          {showErrorMessage && (
            <Form.Control.Feedback type="invalid">
              {fieldState.error?.message}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    />
  )
}
